import React, { useState, useEffect } from "react";
import {
  Typography,
  IconButton,
  Divider,
  Switch,
  FormControl,
  FormGroup,
  FormControlLabel,
} from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "../../styles/changePart.css";
import { ReactComponent as Alert } from "../../assets/images/Alert.svg";
import axios from "axios";
import { automationHttpRequest } from "../../api/httpRequests";
import PartModificationSucess from "./PartModificationSuccess";
import { ToastContainer, toast } from "react-toastify";
import { ReactComponent as Plant } from "../../assets/images/Plant.svg";
import { ReactComponent as DropdownIcon } from "../../assets/images/DropdownIcon.svg";
import { Select, MenuItem, InputAdornment, TextField } from "@mui/material";

const PlantSpecificModification = (props) => {
  const {
    uniqueId,
    materialNumber,
    selectAction,
    handleBackClick,
    handleClose,
  } = props;
  const [modify, setModify] = useState(false);
  const [descriptionValue, setDescriptionValue] = useState({
    maximumStock: "",
    maximumStockLevel: "",
  });
  const [futureValues, setFutureValues] = useState({
    maximumStock: "",
    maximumStockLevel: "",
  });
  const [modifyLoader, setModifyLoader] = useState(false);

  const [minStockCurrentValue, setMinStockCurrentValue] = useState("");
  const [maxStockCurrentValue, setMaxStockCurrentValue] = useState("");
  const [minFutCurrentValue, setMinFutCurrentValue] = useState("");
  const [minFutCurrValueChanged, setMinFutCurrValueChanged] = useState(false);
  const [maxFutCurrValueChanged, setMaxFutCurrValueChanged] = useState(false);
  const [abcFutCurrValueChanged, setAbcFutCurrValueChanged] = useState(false);
  const [maxFutCurrentValue, setMaxFutCurrentValue] = useState("");
  const [minJustValue, setMinJustValue] = useState("");
  const [maxJustValue, setMaxJustValue] = useState("");
  const [requestID, setRequestID] = useState(false);
  const [loading, setLoading] = useState(true);
  const [currAbcIndicator, setCurrAbcIndicator] = useState("");
  const [futAbcIndicator, setFutAbcIndicator] = useState(
    "A : Significant Material",
  );
  const [justiAbcIndicator, setJustiAbcIndicator] = useState("");
  const [critcialIndicator, setCritcialIndicator] = useState("");
  const [storageLocation, setStorageLocation] = useState("");
  const [storageBin, setStorageBin] = useState("");
  const [partModificationDialog, setPartModificationDialog] = useState(false);
  const [dfFlag, setDfFlag] = useState();
  const [dfStorage, setDfStorage] = useState();
  const [plantName, setPlantName] = useState();
  const [noDataAvailable, setNoDataAvailable] = useState(false);
  const [modifyButton, setModifyButton] = useState(false);
  const [futurecritcialIndicator, setFutureCritcialIndicator] = useState("");
  const [futurestorageLocation, setFutureStorageLocation] = useState("");
  const [futurestorageBin, setFutureStorageBin] = useState("");

  const headingStyleNoData = {
    fontSize: 20,
    fontFamily: "Verdana",
    fontWeight: "600",
    margin: "10px 0px 10px 40px",
    color: "#C6003D",
    marginLeft: "500px",
  };

  const headingStyleHeading = {
    fontSize: 14,
    fontFamily: "Verdana",
    fontWeight: "600",
    marginLeft: "20px",
    // margin: "30px 0px 10px 40px",
  };

  const styleInput = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  };

  const inputStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "baseline",
  };
  const ABCoptions = [
    "A : Significant Material",
    "B : Medium Significance",
    "C : Low significance",
  ];

  const handleSelectABCChange = (event) => {
    setModifyButton(true);
    setFutAbcIndicator(event?.target?.value);
  };

  useEffect(() => {
    fetchPlantModificationData();
  }, []);

  useEffect(() => {
    if (
      minFutCurrentValue !== "" &&
      maxFutCurrentValue !== "" &&
      maxFutCurrentValue > 0 &&
      (minFutCurrentValue === 0 || minFutCurrentValue <= maxFutCurrentValue)
    ) {
      setModifyButton(true);
    } else {
      setModifyButton(false);
    }
  }, [maxFutCurrentValue, minFutCurrentValue]);

  const handleToggleChange = () => {
    setModify(!modify);
    if (modify) {
      setDfFlag("");
      setDfStorage("");
    } else {
      setDfFlag("X");
      setDfStorage("X");
    }
    setModifyButton(true);
  };

  const handleInputChange = (e, key) => {
    const value = e.target.value;
    // Perform any validation or processing if needed
    // Update the corresponding state based on the key
    if (key === "minFutCurrentValue") {
      const numericValue = parseInt(value, 10);
      if ((!isNaN(numericValue) && numericValue != "") || numericValue === 0) {
        setMinFutCurrentValue(numericValue);
        setMinFutCurrValueChanged(true);
      }
      if (value === "") {
        setMinFutCurrentValue("");
        setMinFutCurrValueChanged(false);
      }
    } else if (key === "maxFutCurrentValue") {
      // if (parseInt(value, 10) < parseInt(minFutCurrentValue, 10)) {
      //   toast.error("Maximum Stock should be greater than Minimum Stock.", {
      //     position: toast.POSITION.TOP_CENTER,
      //     autoClose: 800,
      //   });
      // }
      if (
        parseInt(value, 10) < parseInt(minFutCurrentValue, 10) ||
        (parseInt(value, 10) === 0 && parseInt(minFutCurrentValue, 10) === 0)
      ) {
        toast.error("Maximum Stock should be greater than Minimum Stock.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 800,
        });
      }
      const numericValue = parseInt(value, 10);
      if ((!isNaN(numericValue) && numericValue != "") || numericValue === 0) {
        setMaxFutCurrentValue(numericValue);
        setMaxFutCurrValueChanged(true);
      }
      if (value === "") {
        setMaxFutCurrentValue("");
        setMaxFutCurrValueChanged(false);
      }
    } else if (key === "minJustValue") {
      setMinJustValue(value);
    } else if (key === "maxJustValue") {
      setMaxJustValue(value);
    } else if (key === "minStockCurrentValue") {
      const numericValue = parseInt(value, 10);
      if (!isNaN(numericValue) && numericValue != "") {
        setMinStockCurrentValue(numericValue);
      }
      if (value === "") {
        setMinStockCurrentValue("");
      }
    } else if (key === "maxStockCurrentValue") {
      const numericValue = parseInt(value, 10);
      if (!isNaN(numericValue) && numericValue != "") {
        setMaxStockCurrentValue(numericValue);
      }
      if (value === "") {
        setMaxStockCurrentValue("");
      }
    }
    setModifyButton(true);
  };

  const handlePlantInputChange = (e, key) => {
    const value = e.target.value;
    // Perform any validation or processing if needed
    // Update the corresponding state based on the key
    setModifyButton(true);
    if (key === "currAbcIndicator") {
      setCurrAbcIndicator(value);
    } else if (key === "futAbcIndicator") {
      setFutAbcIndicator(value);
      setAbcFutCurrValueChanged(true);
    } else if (key === "justiAbcIndicator") {
      setJustiAbcIndicator(value);
    } else if (key === "futurecritcialIndicator") {
      setFutureCritcialIndicator(value);
    } else if (key === "futurestorageLocation") {
      setFutureStorageLocation(value);
    } else if (key === "futurestorageBin") {
      if (value.length <= 10) {
        setFutureStorageBin(value);
      } else {
        toast.error("Limit Exceeded.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 800,
        });
      }
    } else if (key === "currAbcIndicator") {
      setCurrAbcIndicator(value);
    }
  };

  const handleModify = () => {
    setModifyLoader(true);
    updatePlantSpecificModification();
  };
  const handleReset = () => {
    setCurrAbcIndicator("");
    setFutAbcIndicator("");
    setJustiAbcIndicator("");
    setFutureCritcialIndicator("");
    setFutureStorageLocation("");
    setFutureStorageBin("");
    setMinStockCurrentValue("");
    setMaxStockCurrentValue("");
    setMinFutCurrentValue("");
    setMinFutCurrValueChanged(false);
    setMaxFutCurrValueChanged(false);
    setMaxFutCurrentValue("");
    setMinJustValue("");
    setMaxJustValue("");
    setLoading(true);
    fetchPlantModificationData();
    setModifyButton(false);
  };

  const updatePlantSpecificModification = async () => {
    const userEmailId = localStorage.getItem("MRO_user_email");
    const plantId = localStorage.getItem("MRO_user_plantId");
    try {
      const response = await automationHttpRequest.post(
        "/modification_plant_specific_insert/",
        {
          material_number: materialNumber,
          minimum_stock_level:
            minStockCurrentValue === "" || minStockCurrentValue === " "
              ? 0
              : minStockCurrentValue,
          maximum_stock_level:
            maxStockCurrentValue === "" || maxStockCurrentValue === " "
              ? 0
              : maxStockCurrentValue,
          future_maximum_stock_level:
            maxFutCurrentValue === "" || maxFutCurrentValue === " "
              ? 0
              : maxFutCurrentValue,
          future_minimum_stock_level:
            minFutCurrentValue === "" || minFutCurrentValue === " "
              ? 0
              : minFutCurrentValue,
          justification_for_change_in_maximum_stock: maxJustValue,
          justification_for_change_in_minimum_stock: minJustValue,
          df_plant: dfFlag,
          df_storage_location: dfStorage,
          ABC_indicator: currAbcIndicator,
          critical_part: futurecritcialIndicator,
          storage_location: futurestorageLocation,
          storage_bin: futurestorageBin,
          plant_name: plantName,
          plant_id: plantId,
          submitted_by: userEmailId,
          future_abc_indicator: futAbcIndicator,
          justification_for_change_in_abc_indicator: justiAbcIndicator,
          type: "plant_specific",
        },
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
          params: {},
        },
      );
      if (response?.data?.status) {
        setRequestID(response?.data?.data.request_id);
        setModifyLoader(false);
        setPartModificationDialog(true);
      }
    } catch (error) {
      // setModifyLoader(false);
      toast.error("Unable to process the request. Please try again!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 500,
      });
    }
  };

  const fetchPlantModificationData = async () => {
    try {
      const response = await automationHttpRequest.post(
        "/get_plant_specific_modification/",
        {
          // Unique_ID: uniqueId,
          // "material_number": materialNumber,
        },
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
          params: {
            material_number: materialNumber,
            Unique_ID: uniqueId.toString(),
          },
        },
      );
      if (response?.data?.status) {
        if (response?.data?.data.length > 0) {
          setMinStockCurrentValue(response?.data?.data[0].minimum_stock_level);
          setMaxStockCurrentValue(response?.data?.data[0].maximum_stock_level);
          setMinFutCurrentValue(
            response?.data?.data[0].future_minimum_stock_level,
          );
          setMaxFutCurrentValue(
            response?.data?.data[0].future_maximum_stock_level,
          );
          setCurrAbcIndicator(response?.data?.data[0].ABC_indicator);
          setPlantName(response?.data?.data[0].plant_name);
          setFutAbcIndicator(
            response?.data?.data[0].ABC_indicator === "A"
              ? "A : Significant Material"
              : response?.data?.data[0].ABC_indicator === "B"
                ? "B : Medium Significance"
                : response?.data?.data[0].ABC_indicator === "C"
                  ? "C : Low significance"
                  : "",
          );
          setCritcialIndicator(response?.data?.data[0].critical_part);
          setFutureCritcialIndicator(response?.data?.data[0].critical_part);
          setFutureStorageLocation(response?.data?.data[0].storage_location);
          setFutureStorageBin(response?.data?.data[0].storage_bin);
          setStorageLocation(response?.data?.data[0].storage_location);
          setStorageBin(response?.data?.data[0].storage_bin);
          setJustiAbcIndicator("");
          if (response?.data?.data[0].df_plant.trim() === "active") {
            setModify(!true);
          }
          if (response?.data?.data[0].df_storage_location.trim() === "active") {
            setDfStorage("X");
          }
          setLoading(false);
        } else {
          setLoading(false);
          setNoDataAvailable(true);
        }
      }
    } catch (error) {
      // setModifyLoader(false);
      toast.error("Unable to process the request. Please try again!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 500,
      });
    }
  };

  const handleIndicatorSelectChange = (event) => {
    // setChecked(!checked)
    let val = event.target.checked ? "X" : "";
    setFutureCritcialIndicator(val);
    setModifyButton(true);
  };

  const ButtonFamily = ({ btnText }) => {
    return (
      <>
        <button
          type="submit"
          className="submitButton"
          style={{
            top: "20px",
            fontSize: 16,
            cursor: modifyButton ? "pointer" : "default",
            position: "relative",
            fontFamily: "Verdana",
            background: !modifyButton ? "#f5f5f5" : "#C6003D",
            color: modifyButton ? "#FFFFFF" : "#C6003D",
          }}
          onClick={(e) => {
            e.preventDefault();
            handleModify();
          }}
          disabled={!modifyButton}
        >
          {modifyLoader ? (
            // Render loader or loading state here
            <div>Loading...</div>
          ) : (
            // Render button text
            "Modify"
          )}
        </button>
        <button
          type="submit"
          className="submitButton"
          style={{
            top: "20px",
            fontSize: 16,
            cursor: "pointer",
            position: "relative",
            fontFamily: "Verdana",
            background: !modifyButton ? "#f5f5f5" : "#C6003D",
            color: modifyButton ? "#FFFFFF" : "#C6003D",
          }}
          onClick={(e) => {
            e.preventDefault();
            handleReset();
          }}
        >
          Reset
        </button>
        <button
          type="submit"
          className="cancelButton"
          style={{
            top: "20px",
            fontSize: 16,
            cursor: "pointer",
            position: "relative",
            fontFamily: "Verdana",
          }}
          onClick={(e) => {
            e.preventDefault();
            handleBackClick();
          }}
        >
          Cancel
        </button>
      </>
    );
  };

  return (
    <>
      {loading ? (
        <Typography
          sx={{
            // height: "70px",
            fontSize: "18px",
            padding: "20px",
            background: "#fff",
            fontFamily: "Verdana",
          }}
        >
          Loading...
        </Typography>
      ) : (
        <>
          {noDataAvailable ? (
            <Typography style={headingStyleNoData}>
              No Data Available
            </Typography>
          ) : (
            <>
              <div>
                <div style={{ margin: "40px" }}>
                  <div
                    style={{
                      margin: "20px 0px",
                      display: "flex",
                      position: "relative",
                      right: "20px",
                    }}
                  >
                    {/* <Plant /> */}
                    <div style={styleInput}>
                      <Typography style={headingStyleHeading}>
                        Modify Part Details for Plant
                      </Typography>
                      <Typography style={headingStyleHeading}>
                        {plantName}
                      </Typography>
                      {/* <FormControl sx={{ m: 1, width: "200px" }}>
                        <div className="select-container">
                          <input
autoComplete="off" 
                            // placeholder="Part Extension"
                            name="activePart"
                            style={{ background: "#EFEFEF" }}
                            type="text"
                            value={plantName}
                            className="partInputField"
                            disabled
                          />
                        </div>
                      </FormControl> */}
                    </div>
                  </div>
                  <div className="modificationStyle">
                    <Typography
                      sx={{
                        fontFamily: "Verdana",
                        fontSize: "18px",
                        fontWeight: 700,
                        color: "#C6003D",
                      }}
                    >
                      Replenishment Level
                    </Typography>
                  </div>
                  <Divider sx={{ marginTop: "10px", marginBottom: "15px" }} />
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyItems: "center",
                    }}
                  >
                    <div className="inputStyle">
                      <Typography
                        className="headingStyle"
                        sx={{
                          marginTop: "40px",
                          marginRight: "32px",
                          fontFamily: "Verdana",
                          fontWeight: 600,
                        }}
                      >
                        Minimum Stock
                      </Typography>
                    </div>
                    <div className="inputStyle">
                      <Typography
                        className="headingStyle"
                        sx={{
                          fontFamily: "Verdana",
                          fontSize: "13px",
                          fontWeight: 600,
                        }}
                      >
                        Current Value
                      </Typography>
                      <input
                        autoComplete="off"
                        name="abcIndicator"
                        // onChange={handleChange}
                        // type="number"
                        type="text" // Change type to text
                        pattern="[0-9]*"
                        inputmode="numeric"
                        value={minStockCurrentValue}
                        onChange={(e) =>
                          handleInputChange(e, "minStockCurrentValue")
                        }
                        disabled
                        style={{
                          background: "rgb(239, 239, 239)",
                          width: "140px",
                        }}
                        className="partInputField partInputFieldEq"
                        // readOnly
                        // style={{
                        //   backgroundColor: "#f0f0f0",
                        //   cursor: "not-allowed",
                        // }}
                      />
                    </div>
                    <div className="inputStyle">
                      <Typography
                        className="headingStyle"
                        sx={{
                          fontFamily: "Verdana",
                          fontSize: "13px",
                          fontWeight: 600,
                        }}
                      >
                        Proposed Value
                      </Typography>
                      <input
                        autoComplete="off"
                        name="criticalPart"
                        onChange={(e) =>
                          handleInputChange(e, "minFutCurrentValue")
                        }
                        // type="number"
                        type="text" // Change type to text
                        pattern="[0-9]*"
                        inputmode="numeric"
                        style={{
                          width: "140px",
                        }}
                        value={minFutCurrentValue}
                        className="partInputField partInputFieldEq"
                      />
                    </div>

                    {(minFutCurrValueChanged || maxFutCurrValueChanged) && (
                      <div className="inputStyle">
                        <Typography
                          className="headingStyle"
                          sx={{
                            fontFamily: "Verdana",
                            fontSize: "13px",
                            fontWeight: 600,
                            marginLeft: "20px",
                          }}
                        >
                          Reason for Change
                        </Typography>
                        {minFutCurrValueChanged && (
                          <input
                            autoComplete="off"
                            style={{
                              width: "140px",
                              marginLeft: "10px",
                            }}
                            name="bin"
                            onChange={(e) =>
                              handleInputChange(e, "minJustValue")
                            }
                            type="text"
                            // value={values.maximumStock}
                            // disabled={!minFutCurrValueChanged}
                            className="partInputMinStock"
                          />
                        )}
                      </div>
                    )}
                  </div>
                  <Divider style={{ marginTop: "20px" }} />
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    <div className="inputStyle">
                      <Typography
                        className="headingStyle"
                        sx={{
                          marginTop: "40px",
                          marginRight: "30px",
                          fontFamily: "Verdana",
                          fontWeight: 600,
                        }}
                      >
                        Maximum Stock
                      </Typography>
                    </div>
                    <div className="inputStyle">
                      <input
                        autoComplete="off"
                        placeholder=""
                        name="abcIndicator"
                        disabled
                        style={{
                          background: "rgb(239, 239, 239)",
                          marginTop: "35px",
                          width: "140px",
                        }}
                        // onChange={handleChange}
                        // type="number"
                        type="text" // Change type to text
                        pattern="[0-9]*"
                        inputmode="numeric"
                        value={maxStockCurrentValue}
                        className="partInputField partInputFieldEq"
                        // style={{ marginTop: "35px", readOnly
                        onChange={(e) =>
                          handleInputChange(e, "maxStockCurrentValue")
                        }
                        // readOnly
                      />
                    </div>
                    <div className="inputStyle">
                      <input
                        autoComplete="off"
                        style={{
                          marginTop: "35px",
                          width: "143px",
                        }}
                        placeholder=""
                        name="criticalPart"
                        onChange={(e) =>
                          handleInputChange(e, "maxFutCurrentValue")
                        }
                        // type="number"
                        type="text" // Change type to text
                        pattern="[0-9]*"
                        inputmode="numeric"
                        value={maxFutCurrentValue}
                        className="partInputField partInputFieldEq"
                      />
                    </div>
                    {maxFutCurrValueChanged && (
                      <div className="inputStyle">
                        <Typography
                          className="headingStyle"
                          sx={{
                            fontFamily: "Verdana",
                            fontSize: "13px",
                            visibility: "hidden",
                          }}
                        >
                          Reason for Change
                        </Typography>
                        <input
                          autoComplete="off"
                          placeholder=""
                          name="bin"
                          onChange={(e) => handleInputChange(e, "maxJustValue")}
                          type="text"
                          className="partInputField"
                          disabled={!maxFutCurrValueChanged}
                          style={{ marginTop: "15px", width: "140px" }}
                        />
                      </div>
                    )}
                  </div>
                  <Divider style={{ marginTop: "20px" }} />
                  {/* <ButtonFamily btnText="Modify" /> */}
                </div>
              </div>
              <div style={{ margin: "40px" }}>
                <div className="modificationStyle">
                  <Typography
                    sx={{
                      fontFamily: "Verdana",
                      fontSize: "18px",
                      fontWeight: 700,
                      color: "#C6003D",
                    }}
                  >
                    Flag for Deletion
                  </Typography>
                </div>
                <Divider sx={{ marginTop: "10px", marginBottom: "15px" }} />
                <div>
                  <Typography
                    className="headingStyle"
                    sx={{
                      marginBottom: "20px",
                      marginRight: "30px",
                      fontFamily: "Verdana",
                      fontWeight: 600,
                    }}
                  >
                    Deactivate Part
                  </Typography>
                </div>
                <div>
                  {/* <Switch
                    checked={modify}
                    onChange={handleToggleChange}
                    sx={{
                      borderRadius: "50px",
                      //   marginLeft: "25px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      borderRadius: "50px",
                      "& .Mui-checked": {
                        color: "#C6003D", // Change the color to red when the switch is checked
                      },
                    }}
                    inputProps={{ "aria-label": "toggle" }}
                    color="default"
                  /> */}
                  <Switch
                    checked={modify}
                    onChange={handleToggleChange}
                    sx={{
                      borderRadius: "50px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      "& .MuiSwitch-switchBase.Mui-checked": {
                        color: "#C6003D",
                        "& + .MuiSwitch-track": {
                          backgroundColor: "#C6003D",
                        },
                      },
                      "& .MuiSwitch-switchBase:hover": {
                        backgroundColor: "rgba(198, 0, 61, 0.08)",
                      },
                      "& .MuiSwitch-track": {
                        borderRadius: "50px",
                        backgroundColor: "#E9E9EA",
                        opacity: 1,
                      },
                    }}
                    inputProps={{ "aria-label": "toggle" }}
                    color="default"
                  />
                </div>
              </div>
              <div>
                <div style={{ margin: "40px" }}>
                  <div className="modificationStyle">
                    <Typography
                      sx={{
                        fontFamily: "Verdana",
                        fontSize: "18px",
                        fontWeight: 700,
                        color: "#C6003D",
                      }}
                    >
                      Plant Changes
                    </Typography>
                  </div>
                  <Divider sx={{ marginTop: "10px", marginBottom: "15px" }} />
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    <div className="column" style={{ flex: "0.5" }}>
                      <Typography
                        className="headingStyle"
                        sx={{
                          marginTop: "32px",
                          marginRight: "30px",
                          fontFamily: "Verdana",
                          fontWeight: 600,
                        }}
                      >
                        ABC Indicator
                      </Typography>
                    </div>
                    <div className="column" style={{ flex: "0.5" }}>
                      <Typography
                        className="headingStyle"
                        sx={{
                          fontFamily: "Verdana",
                          fontSize: "13px",
                          marginLeft: "13px",
                          fontWeight: 600,
                        }}
                      >
                        Current Value
                      </Typography>

                      <input
                        autoComplete="off"
                        name="abcIndicator"
                        className="partInputField"
                        disabled
                        value={currAbcIndicator}
                        style={{
                          background: "rgb(239, 239, 239)",
                          width: "140px",
                        }}
                        onChange={(e) =>
                          handlePlantInputChange(e, "currAbcIndicator")
                        }

                        // style={{
                        //   backgroundColor: "#f0f0f0",
                        //   cursor: "not-allowed",
                        // }}
                        // readOnly
                      />
                    </div>
                    <div className="column" style={{ flex: "0.5" }}>
                      <Typography
                        className="headingStyle"
                        sx={{
                          fontFamily: "Verdana",
                          fontSize: "13px",
                          fontWeight: 600,
                          position: "relative",
                          left: "12px",
                        }}
                      >
                        Proposed Value
                      </Typography>
                      {/* <input
autoComplete="off" 
                        name="futAbcIndicator"
                        onChange={(e) =>
                          handlePlantInputChange(e, "futAbcIndicator")
                        }
                        style={{
                          width: "140px"
                        }} 
                        type="text"
                        value={futAbcIndicator}
                        className="partInputField"
                      /> */}
                      <FormControl
                        sx={{ width: "136px", margin: "10px 20px 8px 10px" }}
                      >
                        <Select
                          value={futAbcIndicator}
                          onChange={handleSelectABCChange}
                          sx={{ height: "32px" }}
                        >
                          {ABCoptions.map((option) => (
                            <MenuItem key={option} value={option}>
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    {/* {!abcFutCurrValueChanged && (
                      <div className="column" style={{ flex: "1.5" }}></div>
                    )} */}
                    {/* {abcFutCurrValueChanged && ( */}
                    <div
                      className="column"
                      style={{
                        flex: "0.5",
                        visibility: abcFutCurrValueChanged
                          ? "visible"
                          : "hidden",
                      }}
                    >
                      <Typography
                        className="headingStyle"
                        sx={{
                          fontFamily: "Verdana",
                          fontSize: "13px",
                          fontWeight: 600,
                          position: "relative",
                          left: "20px",
                        }}
                      >
                        Reason for Change
                      </Typography>
                      <input
                        autoComplete="off"
                        style={{
                          width: "140px",
                        }}
                        name="justiAbcIndicator"
                        onChange={(e) =>
                          handlePlantInputChange(e, "justiAbcIndicator")
                        }
                        type="text"
                        value={justiAbcIndicator}
                        className="partInputField"
                        //   disabled={!minFutCurrValueChanged}
                      />
                    </div>
                    {/* )} */}
                  </div>
                  <Divider />
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    <div className="column" style={{ flex: "0.5" }}>
                      <Typography
                        className="headingStyle"
                        sx={{
                          marginTop: "33px",
                          marginRight: "30px",
                          fontFamily: "Verdana",
                          fontWeight: 600,
                        }}
                      >
                        Criticality Indicator
                      </Typography>
                    </div>
                    <div
                      className="column"
                      style={{ flex: "0.5", marginTop: "20px" }}
                    >
                      <input
                        autoComplete="off"
                        name="critcialIndicator"
                        disabled
                        style={{
                          background: "rgb(239, 239, 239)",
                          width: "140px",
                        }}
                        // onChange={(e) =>
                        //   handlePlantInputChange(e, "critcialIndicator")
                        // }
                        type="text"
                        value={critcialIndicator}
                        className="partInputField"
                      />
                    </div>
                    <div
                      className="column"
                      style={{ flex: "0.5", marginTop: "20px" }}
                    >
                      {/* <FormControl sx={{
                        borderRadius: "8px",
                        margin: "10px 20px 10px 10px !important",
                        width: "140px",
                        outlineStyle: "none",
                        border: "1px solid #cbc3c3",
                        textAlign: "center"
                      }}>
                        <Select
                          value={futurecritcialIndicator}
                          onChange={handleIndicatorSelectChange}
                          renderValue={(selected) => (
                            <div>
                              <span key={selected}>{selected}</span>
                            </div>
                          )}
                          sx={{
                            padding: "0px !important",
                            height: "32px"
                          }}
                        >
                          <MenuItem value="">
                            <Checkbox checked={futurecritcialIndicator === ""} />
                            <ListItemText primary="Blank" />
                          </MenuItem>
                          <MenuItem value="X">
                            <Checkbox checked={futurecritcialIndicator === "X"} />
                            <ListItemText primary="X" />
                          </MenuItem>
                        </Select>
                      </FormControl> */}
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={futurecritcialIndicator === "X"}
                              style={{
                                color: "#575555",
                                position: "relative",
                                left: "65px",
                              }}
                              onChange={handleIndicatorSelectChange}
                            />
                          }
                          // label="My Checkbox"
                        />
                      </FormGroup>
                      {/* <input
                        autoComplete="off"
                        style={{
                          width: "1400px",
                        }}
                        placeholder=""
                        name="futurecritcialIndicator"
                        onChange={(e) =>
                          handlePlantInputChange(e, "futurecritcialIndicator")
                        }
                        className="partInputField"
                        value={futurecritcialIndicator}
                        onChange={(e) =>
                        setFutureValues({
                          ...futureValues,
                          criticalPart: e.target.value,
                        })
                      }
                      /> */}
                    </div>
                    <div
                      className="column"
                      style={{
                        flex: "0.5",
                        marginTop: "20px",
                        visibility: "hidden",
                      }}
                    >
                      <input
                        autoComplete="off"
                        style={{
                          width: "140px",
                        }}
                        placeholder=""
                        name="criticalPart"
                        className="partInputField"
                        // value={justifications.abcIndicator}
                        // onChange={(e) =>
                        //   setJustifications({
                        //     ...justifications,
                        //     criticalPart: e.target.value,
                        //   })
                        // }
                      />
                    </div>
                  </div>

                  <Divider />
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    <div className="column" style={{ flex: "0.5" }}>
                      <Typography
                        className="headingStyle"
                        sx={{
                          marginTop: "33px",
                          marginRight: "30px",
                          fontFamily: "Verdana",
                          fontWeight: 600,
                        }}
                      >
                        Storage Location
                      </Typography>
                    </div>
                    <div
                      className="column"
                      style={{ flex: "0.5", marginTop: "20px" }}
                    >
                      <input
                        autoComplete="off"
                        disabled
                        name="storageLocation"
                        style={{
                          background: "rgb(239, 239, 239)",
                          width: "140px",
                        }}
                        // onChange={(e) =>
                        //   handlePlantInputChange(e, "storageLocation")
                        // }
                        type="text"
                        value={storageLocation}
                        className="partInputField"
                      />
                    </div>
                    <div
                      className="column"
                      style={{ flex: "0.5", marginTop: "20px" }}
                    >
                      <input
                        autoComplete="off"
                        placeholder=""
                        name="futurestorageLocation"
                        onChange={(e) =>
                          handlePlantInputChange(e, "futurestorageLocation")
                        }
                        style={{
                          width: "140px",
                        }}
                        className="partInputField"
                        value={futurestorageLocation}
                        // onChange={(e) =>
                        //   setFutureValues({
                        //     ...futureValues,
                        //     sloc: e.target.value,
                        //   })
                        // }
                      />
                    </div>
                    <div
                      className="column"
                      style={{
                        flex: "0.5",
                        marginTop: "20px",
                        visibility: "hidden",
                      }}
                    >
                      <input
                        autoComplete="off"
                        style={{
                          width: "140px",
                        }}
                        placeholder=""
                        name="criticalPart"
                        className="partInputField"
                        // value={futureValues.abcIndicator}
                        // onChange={(e) =>
                        //   setJustifications({
                        //     ...justifications,
                        //     criticalPart: e.target.value,
                        //   })
                        // }
                      />
                    </div>
                  </div>

                  <Divider />
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    <div className="column" style={{ flex: "0.5" }}>
                      <Typography
                        className="headingStyle"
                        sx={{
                          marginTop: "35px",
                          marginRight: "30px",
                          fontFamily: "Verdana",
                          fontWeight: 600,
                        }}
                      >
                        Storage Bin
                      </Typography>
                    </div>

                    <div
                      className="column"
                      style={{ flex: "0.5", marginTop: "20px" }}
                    >
                      <input
                        autoComplete="off"
                        name="storageBin"
                        disabled
                        style={{
                          background: "rgb(239, 239, 239)",
                          width: "140px",
                        }}
                        // onChange={(e) =>
                        //   handlePlantInputChange(e, "storageBin")
                        // }
                        type="text"
                        value={storageBin}
                        className="partInputField"
                      />
                    </div>
                    <div
                      className="column"
                      style={{ flex: "0.5", marginTop: "20px" }}
                    >
                      <input
                        autoComplete="off"
                        placeholder=""
                        name="futurestorageBin"
                        onChange={(e) =>
                          handlePlantInputChange(e, "futurestorageBin")
                        }
                        style={{
                          width: "140px",
                        }}
                        className="partInputField"
                        value={futurestorageBin}
                        // onChange={(e) =>
                        //   setFutureValues({
                        //     ...futureValues,
                        //     bin: e.target.value,
                        //   })
                        // }
                      />
                    </div>
                    <div
                      className="column"
                      style={{
                        flex: "0.5",
                        marginTop: "20px",
                        visibility: "hidden",
                      }}
                    >
                      <input
                        autoComplete="off"
                        placeholder="-"
                        style={{
                          width: "140px",
                        }}
                        name="criticalPart"
                        className="partInputField"
                        // value={justifications.bin}
                        // onChange={(e) =>
                        //   setJustifications({
                        //     ...justifications,
                        //     criticalPart: e.target.value,
                        //   })
                        // }
                      />
                    </div>
                  </div>
                  <Divider sx={{ marginTop: "30px" }} />
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <ButtonFamily btnText="Modify" />
                  </div>
                </div>
              </div>
            </>
          )}
          <ToastContainer />
          <PartModificationSucess
            partModificationDialog={partModificationDialog}
            setPartModificationDialog={setPartModificationDialog}
            requestID={requestID}
            handleClose={handleClose}
          />
        </>
      )}
    </>
  );
};

export default PlantSpecificModification;
